import { render, staticRenderFns } from "./social-media-links.vue?vue&type=template&id=bada7406&"
import script from "./social-media-links.vue?vue&type=script&lang=js&"
export * from "./social-media-links.vue?vue&type=script&lang=js&"
import style0 from "./social-media-links.vue?vue&type=style&index=0&id=bada7406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports